export default __webpack_public_path__ + "static/studycafe-study4-5a8dfcfac178b7a21b12b537110e08f4.jpg";